import React from 'react';
import Tabs from '@mulesoft/anypoint-components/lib/Tabs';
import TabList from '@mulesoft/anypoint-components/lib/TabList';
import Tab from '@mulesoft/anypoint-components/lib/Tab';
import TabPanel from '@mulesoft/anypoint-components/lib/TabPanel';
import TabPanelReview from './TabPanelReview';
import { tabTheme } from '~/components/AgentScanners/types/commonTypes';
import { agentsMock } from '../mock';
import styles from './Review.css';

const Review = () => {
  return (
    <div className={styles.detailSection} data-test-id="scan-review-section">
      <h2>Scan Review</h2>
      <Tabs>
        <TabList>
          <Tab testId="test-tab-imported" theme={tabTheme}>
            Imported new (2)
          </Tab>
          <Tab testId="test-tab-updated" theme={tabTheme}>
            Updated existing(1)
          </Tab>
          <Tab testId="test-tab-removed" theme={tabTheme}>
            Removed missing(1)
          </Tab>
          <Tab testId="test-tab-already" theme={tabTheme}>
            Review current (1)
          </Tab>
          <Tab testId="test-tab-not-updated" theme={tabTheme}>
            Unsuccessful (2)
          </Tab>
        </TabList>
        <TabPanel>
          <TabPanelReview
            title="Imported"
            subtitle="These agents were found in the external system but didn’t exist in Exchange."
            typeStyle={styles.reviewImported}
            agents={agentsMock[0]}
          />
        </TabPanel>
        <TabPanel>
          <TabPanelReview
            title="Update existing agents"
            subtitle="These agents exist in your Exchange but have newer versions available."
            typeStyle={styles.reviewUpdated}
            agents={agentsMock[1]}
          />
        </TabPanel>
        <TabPanel>
          <TabPanelReview
            title="Remove missing agents"
            subtitle="These agents exist in your Exchange but were not found in the source system."
            typeStyle={styles.reviewRemove}
            agents={agentsMock[2]}
          />
        </TabPanel>
        <TabPanel>
          <TabPanelReview
            title="Review current agents"
            subtitle="These agents are already up-to-date in your Exchange."
            typeStyle={styles.reviewCurrent}
            agents={agentsMock[3]}
          />
        </TabPanel>
        <TabPanel>
          <TabPanelReview
            title="Unsuccessful"
            subtitle="These agents were not imported due to an issue. It will be reattempted in the next scan."
            typeStyle={styles.reviewImported}
            agents={agentsMock[4]}
          />
        </TabPanel>
      </Tabs>
    </div>
  );
};

export default Review;
